import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1225924005713338';
const FacebookPixel = () => {
  useEffect(() => {
    // If fbq already exists (loaded from index.html), just ensure init + PageView
    if (typeof window !== 'undefined' && window.fbq) {
      console.log('✅ Meta Pixel ya estaba cargado desde HTML');
      return;
    }
    // === INSTALL PIXEL FROM REACT (fallback if index.html didn't load it) ===
    try {
      // 1. Create fbq function
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // 2. Inject the fbevents.js script into <head>
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => {
        console.log('✅ Meta Pixel script cargado desde React');
      };
      script.onerror = () => {
        console.error('❌ Error cargando Meta Pixel script (posible ad blocker)');
      };
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      // 3. Initialize pixel and fire PageView
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
      console.log(`✅ Meta Pixel inicializado con ID: ${PIXEL_ID}`);
      // 4. Also inject noscript fallback image
      const noscriptImg = document.createElement('img');
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      document.body.appendChild(noscriptImg);
    } catch (error) {
      console.error('❌ Error al instalar Meta Pixel:', error);
    }
  }, []);
  return null;
};
export default FacebookPixel;